import { Box } from '@material-ui/core'
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab'
import { CustomTooltip } from 'components/facets'
import { useInventoryStore } from 'lib/hooks/useInventoryStore'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { INVENTORY_ZOOM_LEVELS } from 'shared'
import { LISTING_AND_APPRAISAL } from 'utils/constants'
import { Filter } from '../FilterDock/Filter'
import HeaderRow from './HeaderRow'
import './stock-display.css'

const ChangeViewRow = ({
  selectedSize,
  setSelectedSize,
  parentPage,
  editedStockExists,
}: {
  selectedSize: number
  setSelectedSize: React.Dispatch<React.SetStateAction<number>>
  parentPage: string
  editedStockExists: boolean
}): JSX.Element => {
  const { t } = useTranslation()
  // const activeStockType = useStockStore((s) => s.activeStockType)
  const { zoomLevel, setZoomLevel } = useInventoryStore()
  const [toggleZoomLevel, setToggleZoomLevel] = useState(zoomLevel)
  const [disableGroupLocation, setDisableGroupLocation] = useState(false)
  disableGroupLocation

  const handleChangeZoomLevel = (_: any, value: string) => {
    if (value) {
      setToggleZoomLevel(value)
      setZoomLevel(value)
    }
  }

  const handleChangeCardsSize = (newValue: number): void => {
    setSelectedSize(newValue)
    localStorage.setItem('selectedCardsSize', newValue.toString())
  }

  useEffect(() => {
    setDisableGroupLocation(editedStockExists)
  }, [editedStockExists])

  return (
    <HeaderRow>
      {parentPage !== LISTING_AND_APPRAISAL && (
        <div className="pe-sm-2 pe-l-0">
          <ToggleButtonGroup
            value={toggleZoomLevel}
            exclusive
            onChange={handleChangeZoomLevel}
            className="group-location-toggle"
          >
            <ToggleButton
              value={INVENTORY_ZOOM_LEVELS.ARTICLE}
              data-testid="zoom-level-group-location"
              disabled={disableGroupLocation}
            >
              <CustomTooltip
                title={t('stockPricing.bulkEdit.groupLocation') as string}
                placement="top"
              >
                <i className="fa-solid fa-object-exclude" />
              </CustomTooltip>
            </ToggleButton>

            <ToggleButton
              value={INVENTORY_ZOOM_LEVELS.LOCATION}
              data-testid="zoom-level-expand-location"
              disabled={disableGroupLocation}
            >
              <CustomTooltip
                title={t('stockPricing.bulkEdit.ungroupLocation') as string}
                placement="top"
              >
                <i className="fa-light fa-object-union" />
              </CustomTooltip>
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
      )}
      <Box width={200} marginLeft={2}>
        <Filter
          defaultValue={selectedSize}
          data-testid="cardsSize-slider"
          type="slider"
          sliderProps={{
            valueLabelDisplay: 'auto',
            step: 1,
            marks: true,
            min: 1,
            max: 9,
          }}
          name="size"
          setFilter={(_name, newValue) => handleChangeCardsSize(newValue)}
          label={t('stockPricing.cardsSize')}
        />
      </Box>
    </HeaderRow>
  )
}

export default ChangeViewRow
